import { Utils } from 'mw-style-react';

export const GET_NOTIFICATION_SETTINGS = Utils.createRequestTypes(
  'GET_NOTIFICATION_SETTINGS'
);
export const ADD_NOTIFICATION_SETTINGS = Utils.createRequestTypes(
  'ADD_NOTIFICATION_SETTINGS'
);
export const DELETE_NOTIFICATION_SETTINGS = Utils.createRequestTypes(
  'DELETE_NOTIFICATION_SETTINGS'
);
export const MANAGE_NOTIFICATION_CHANNEL = Utils.createRequestTypes(
  'MANAGE_NOTIFICATION_CHANNEL'
);
export const MANAGE_NOTIFICATION_SETTINGS = Utils.createRequestTypes(
  'MANAGE_NOTIFICATION_SETTINGS'
);

export const NOTIFY_TYPES = {
  global: 'global',
  globalEvents: 'globalEvents',
  globalChats: 'globalChats',
  globalActors: 'globalActors',
  sysStream: 'sysStream',
  stream: 'stream',
  actor: 'actor',
};

export const NOTIFY_CHANNELS = {
  email: 'email',
  mobPush: 'mobPush',
  webPush: 'webPush',
  sound: 'sound',
};

export const SYSTEM_STREAMS = {
  execute: 'execute',
  group: 'group',
  sign: 'sign',
  p2p: 'p2p',
};

export const SNOOZE_TIMES = {
  FOREVER: null,
  ONE_HOUR: 60,
  THREE_HOURS: 180,
  ONE_DAY: 1440,
};

export const MINUTES_IN_SNOOZE_HOUR = 60;
